/**
 * Directive for triggering a function,
 * whenever there is clicked outside the element bounded on.
 *
 * @see https://stackoverflow.com/a/65735656/18222092 Heavily inspiration
 */
export default {
  beforeMount: (el, binding) => {
    const config = Object.assign(
      {
        handler: () => ({}),
        activator: undefined
      },
      binding.value
    );

    el.eventSetDrag = () => {
      el.setAttribute("data-dragging", "yes");
    };
    el.eventClearDrag = () => {
      el.removeAttribute("data-dragging");
    };
    el.eventOnClick = (event) => {
      const dragging = el.getAttribute("data-dragging");

      // Check that the click was outside the el and its children, and wasn't a drag
      if (el === event.target || el.contains(event.target)) {
        return;
      }

      if (
        config.activator &&
        (config.activator === event.target || config.activator.contains(event.target))
      ) {
        return;
      }

      if (dragging) {
        return;
      }

      // Call method provided in attribute value
      config.handler(event);
    };
    document.addEventListener("touchstart", el.eventClearDrag);
    document.addEventListener("touchmove", el.eventSetDrag);
    document.addEventListener("click", el.eventOnClick);
    document.addEventListener("touchend", el.eventOnClick);
  },
  unmounted: (el) => {
    document.removeEventListener("touchstart", el.eventClearDrag);
    document.removeEventListener("touchmove", el.eventSetDrag);
    document.removeEventListener("click", el.eventOnClick);
    document.removeEventListener("touchend", el.eventOnClick);
    el.removeAttribute("data-dragging");
  }
};
